var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import ServiceRequestTable from "./ServiceRequestTable";
import { TodaysDate, getFinancialYear } from "@domains/utils/reportDates";
import moment from "moment";
import CalendarPopupDesk from "../../../../../shared-library/components/Calendar/CalendarPopupDesk";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
var ServiceRequest = function () {
    var _a = __read(React.useState(getFinancialYear(new Date())), 2), finYear = _a[0], setFinYear = _a[1];
    var _b = __read(React.useState(false), 2), openCalendar = _b[0], setOpenCalendar = _b[1];
    var _c = __read(React.useState(finYear + 1), 2), nextFinYear = _c[0], setNextFinYear = _c[1];
    var _d = __read(React.useState(new Date(finYear + 1, 2, 31)), 2), endDate = _d[0], setEndDate = _d[1];
    var _e = __read(React.useState(new Date(finYear, 3, 1)), 2), startDate = _e[0], setStartDate = _e[1];
    var _f = __read(React.useState(""), 2), searchText = _f[0], setSearchText = _f[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-flex justify-content-between align-items-center service-calendar-search" },
            React.createElement("div", { className: "sales-calendar" },
                React.createElement("div", { className: "d-flex calendar-block m-0" },
                    React.createElement("label", { className: "txt_blackOne1 DMSansMedium_20_500" },
                        "FY ",
                        finYear,
                        "-",
                        nextFinYear.toString().substring(2),
                        React.createElement("span", { className: "DMSansNormal_20_400" },
                            "\u00A0(",
                            moment(startDate).format("D-MMM-YY"),
                            "\u00A0 to ",
                            moment(endDate).format("D-MMM-YY"),
                            ")")),
                    React.createElement("i", { className: "edel-icon-calendar2 txt-midnight-blue" }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Change", onClick: function () { return setOpenCalendar(!openCalendar); } })),
                React.createElement(CalendarPopupDesk, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear, lastQuarter: true, ToDatemax: TodaysDate, lastQuarterYear: getFinancialYear(new Date()) - 1 })),
            React.createElement(SearchBar, { parentClassName: "service-input", openInputBackground: "bg_white", searchBarBackground: "bg_white", iconColors: "", deskPlaceHolder: "Service Request Id", onCallbackFunction: function (searchText) {
                    setSearchText(searchText);
                } })),
        React.createElement(ServiceRequestTable, { startDate: startDate, endDate: endDate, searchText: searchText })));
};
export default ServiceRequest;
